import React from 'react';
import { Text, MessageBox, LoaderDots } from '@reservamos/elements';
import useCostapassState from 'hooks/useCostapassState';
import { useTranslation } from 'react-i18next';
import formatPhonePrivacy from 'utils/formatPhonePrivacy';
import formatEmailPrivacy from 'utils/formatEmailPrivacy';
import ConfirmationMethod from './RedeemPointsMethod';
import { useRedeemContext } from '../../RedeemHandlerContext';

/**
 * @description Confirmation methods component
 * @returns {React.ReactNode}
 */
const RedeemPointsMethods = () => {
  const { isCreating, onSendCode, optContactMethod, selectedMethod, onSelectMethod, error } =
    useRedeemContext();

  const {
    profile: { email, phone },
  } = useCostapassState();
  const { t } = useTranslation(['payment', 'notifications']);

  return (
    <div>
      <div className="mb-5">
        <Text color="grayMedium" size="L">
          {t('wallet_instructions.select_method')}
        </Text>
      </div>
      <div className="flex flex-col gap-6">
        {['email', 'both'].includes(optContactMethod) && (
          <ConfirmationMethod
            label={t('wallet_methods.email')}
            checked={selectedMethod === 'email'}
            onChange={() => onSelectMethod('email')}
            data={formatEmailPrivacy(email || '')}
            iconType="Email"
            disabled={isCreating}
          />
        )}
        {['sms', 'both'].includes(optContactMethod) && (
          <ConfirmationMethod
            label={t('wallet_methods.sms')}
            checked={selectedMethod === 'sms'}
            onChange={() => onSelectMethod('sms')}
            data={formatPhonePrivacy(phone || '')}
            iconType="Mobile"
            disabled={isCreating}
          />
        )}
        {error === 'generateNITCode' && (
          <MessageBox borderColor="error">
            <Text color="error" size="L">
              {t('notifications:error.generating_code')}
            </Text>
          </MessageBox>
        )}
        <button
          className="w-full custom-gradient-btn"
          type="button"
          onClick={() => onSendCode()}
          disabled={isCreating}
        >
          {isCreating ? <LoaderDots /> : t('wallet_methods.send_code')}
        </button>
      </div>
    </div>
  );
};

export default RedeemPointsMethods;
